import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from './Grid.jsx';

class ContasCentro extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [
                "Código",
                "Conta",
                "Tipo de Conta",
                "Natureza da Conta",
                "Cultura",
                "Investimento" ],
            contas: [],
            centroId: 0,
            centro: ""
        };

        this.voltar = this.voltar.bind(this);
        this.cadastrar = this.cadastrar.bind(this);
        this.tiposConta = this.tiposConta.bind(this);

    }

    voltar() {
        this.props.history.push("/contas");
    }

    cadastrar() {

        let obj = {
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/cadastrarconta",
            state: obj
        });

    }

    tiposConta() {

        let obj = {
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/tiposconta",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleContas === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let cId = this.props.location.state.row.id;
        let centroNome = this.props.location.state.row.data[0];
        this.setState({ centroId: cId });
        this.setState({ centro: centroNome });

        fetch("/api/conta/grid/" + cId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ contas: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="contas-centro-title">Contas</h1><br />
                <br />
                <p id="contas-centro-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <Grid key={ this.state.contas }
                    header={ this.state.gridHeader }
                    data={ this.state.contas }
                    pageSize={ 10 }
                    gridWidth={ "950px" }
                    linkTo={ "/visualizarconta" } />
                <br />
                <button id="contas-centro-voltar-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                { localStorage.roleContas === "escrever" &&
                    <button id="contas-centro-cadastrar-btn" onClick={ this.cadastrar }>
                        Cadastrar Conta
                    </button> }
                <button id="contas-centro-tipo-btn" onClick={ this.tiposConta }>
                    Tipos de Conta
                </button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(ContasCentro);

